import { render, staticRenderFns } from "./PopoverLoadingIndicator.vue?vue&type=template&id=9bd90324&"
import script from "./PopoverLoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./PopoverLoadingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd90324')) {
      api.createRecord('9bd90324', component.options)
    } else {
      api.reload('9bd90324', component.options)
    }
    module.hot.accept("./PopoverLoadingIndicator.vue?vue&type=template&id=9bd90324&", function () {
      api.rerender('9bd90324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Popover/PopoverLoadingIndicator.vue"
export default component.exports